module.exports = __webpack_public_path__ + "static/media/pjedit.ba8210f0.svg";